export class Setor {
    id: string;
    depDescricao: string;
}
